/**
 * One Trading Arrival, on the shared one-page arrival sheet (user, 2026-09-19) like every other
 * arrival form except the cob chain. The route stays static only because `trading/` already owns the
 * path; it shows exactly what `$form/$id` shows for any other single-document form.
 *
 * The bespoke Trading page (`features/arrival/trading/trading-page.tsx`) is no longer routed to.
 */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { ArrivalScreen } from "@/features/arrival/components/arrival-screen";
import { useAuth } from "@/features/auth/store";

export const Route = createFileRoute("/_app/arrivals/trading/$id")({
  params: {
    parse: ({ id }) => {
      if (!/^\d+$/.test(id)) throw notFound();
      return { id };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    const auth = useAuth.getState();
    if (!auth.can("document.view") || !auth.canViewForm("arrival_trading"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <ArrivalScreen id={Number(id)} />;
}
